import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';

export namespace ErrorMapping {
  export const from = (error: any): string => {
    if (error instanceof Error) return fromError(error);

    return pipe(
      option.tryCatch(() => JSON.stringify(error)),

      option.getOrElse(() => BASE_ERROR_MSG)
    );
  };

  const fromError = (error: Error): string =>
    JSON.stringify({
      name: error.name,
      stack: error.stack,
      message: error.message,
    });

  const BASE_ERROR_MSG = 'Unknown error';
}
